import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { isParamEmpty } from "@/filters/index";
import { getToken } from "@/utils/auth"; // Token
import { findNodeByCode } from '@/utils/index'
import { substationList } from '@/assets/json/data'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

// 未登录的权限用户不可访问的路由；
const whiteList = [

];

const getBaseUrl = () => {
  const path = location.pathname.split('/')
  const item = findNodeByCode(substationList, path.includes('subplatform') ? path[2] : path[1])
  let subPath =
    (item &&
      (item.parentPath ? item.parentPath + '/' + item.path : item.path)) ||
    ''
  return '/' + subPath
}

const router = new Router({
  mode: "history",
  base: getBaseUrl(),
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [

    {
      path: "/",
      redirect: "/index",
      meta: { keepAlive: true }
    },
      {
          path: '/notice/detail',
          name: 'NoticeDetail',
          component: () => import("@/pageViews/indexPage/noticeDetail.vue"),
          meta: {
              title: '公告详情'
          }
      },
      {
          path: '/electr/uploadFile',
          name: 'electruploadFile',
          component: () => import("@/pageViews/electr/index.vue"),
          meta: {
              title: '公告详情'
          }
      },
      // 惠企政策 H5（手机扫码访问）
      {
          path: '/policyH5',
          name: 'policyH5',
          component: () => import("@/MobileViews/policy/list.vue"),
          meta: {
              title: '惠企政策'
          }
      },
      {
          path: '/policyH5/detail',
          name: 'policyH5Detail',
          component: () => import("@/MobileViews/policy/detail.vue"),
          meta: {
              title: '政策详情'
          }
      },
    {
      path: "/PlatFormIndex",
      component: () => import("@/pageViews/index.vue"),
      hidden: true,
      children: [
        // 首页
        {
          path: "/index",
          name: "index",
          component: () => import("@/pageViews/indexPage/index.vue"),
          meta: { keepAlive: true }
        },
        // 统一认证登陆中转页
        {
          path: '/redirectLogin',
          component: () => import('@/pageViews/redirectLogin'),
          meta: { title: '统一认证登陆中转页' }
        },
          {
              path: '/thirdLogin',
              component: () => import('@/pageViews/thirdLogin'),
              meta: { title: '登录中...' }
          },
        // 金融超市
        {
          path: "/financialIndex",
          component: () => import("@/pageViews/financialPage/main.vue"),
          hidden: true,
          children: [
            {
              path: "/financial",
              name: "financial",
              component: (resolve) => require(["@/pageViews/financialPage/index.vue"], resolve),
              meta: { keepAlive: false }
            },
            {
              path: "/productDetails",
              name: "productDetails",
              component: (resolve) => require(["@/pageViews/financialPage/product-details.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'financial' }
            },
              {
                  path: "/productDetailsdl",
                  name: "productDetailsdl",
                  component: (resolve) => require(["@/pageViews/financialPage/product-details-dl.vue"], resolve),
                  meta: { keepAlive: false, activeMenu: 'financial' }
              },
            {
              path: "/projectDetails",
              name: "projectDetails",
              component: (resolve) => require(["@/pageViews/financialPage/project-details.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'financial' }
            },
            {
              path: "/orgDetails",
              name: "orgDetails",
              component: (resolve) => require(["@/pageViews/financialPage/org-details.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'financial' }
            },
          ]
        },
        // 特色专区
        {
          path: "/characteristicAreaIndex",
          component: () => import("@/pageViews/characteristicArea/main.vue"),
          hidden: true,
          children: [
            {
              path: "/characteristicArea",
              name: "characteristicArea",
              component: (resolve) => require(["@/pageViews/characteristicArea/index.vue"], resolve),
              meta: { keepAlive: false }
            },
            {
              path: "/financialZone",
              name: "financialZone",
              component: (resolve) => require(["@/pageViews/characteristicArea/financial-zone.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/revitalization",
              name: "revitalization",
              component: (resolve) => require(["@/pageViews/characteristicArea/revitalization.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/benefitEnt",
              name: "benefitEnt",
              component: (resolve) => require(["@/pageViews/characteristicArea/benefitEnt.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/gardenArea",
              name: "gardenArea",
              component: (resolve) => require(["@/pageViews/characteristicArea/gardenArea/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/entDetail",
              name: "entDetail",
              component: (resolve) => require(["@/pageViews/characteristicArea/gardenArea/entDetail.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/supplyChain",
              name: "supplyChain",
              component: (resolve) => require(["@/pageViews/characteristicArea/supplyChain/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/governmentMiningLoan",
              name: "governmentMiningLoan",
              component: (resolve) => require(["@/pageViews/characteristicArea/governmentMiningLoan.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
              {
                  path: "/governmentMiningDetail",
                  name: "governmentMiningDetail",
                  component: (resolve) => require(["@/pageViews/characteristicArea/govermentMiningdetails.vue"], resolve),
                  meta: { keepAlive: false, activeMenu: 'characteristicArea' }
              },
            {
              path: "/fundList",
              name: "fundList",
              component: (resolve) => require(["@/pageViews/characteristicArea/financialZone/fundList.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/leaseForm",
              name: "leaseForm",
              component: (resolve) => require(["@/pageViews/characteristicArea/financialZone/leaseForm.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/article",
              name: "article",
              component: (resolve) => require(["@/pageViews/characteristicArea/article/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/articleInfo",
              name: "articleInfo",
              component: (resolve) => require(["@/pageViews/characteristicArea/article/info.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/rosterPublicity",
              name: "rosterPublicity",
              component: (resolve) => require(["@/pageViews/characteristicArea/article/rosterPublicity.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
            {
              path: "/lanbaiZone",
              name: "lanbaiZone",
              component: (resolve) => require(["@/pageViews/characteristicArea/lanbaiZone/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'characteristicArea' }
            },
          ]
        },
        // 项目信息
        {
          path: "/projectInfoIndex",
          component: () => import("@/pageViews/projectInfo/main.vue"),
          hidden: true,
          children: [
            {
              path: "/projectInfo",
              name: "projectInfo",
              component: (resolve) => require(["@/pageViews/projectInfo/index.vue"], resolve),
              meta: { keepAlive: false }
            },
            {
              path: "/fabricate",
              name: "fabricate",
              component: (resolve) => require(["@/pageViews/projectInfo/fabricate.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'projectInfo' }
            },
          ]
        },
        // 首贷中心
        {
          path: "/disasterIndex",
          component: () => import("@/pageViews/disaster/main.vue"),
          hidden: true,
          children: [
            {
              path: '/disaster',
              name: "disaster",
              component: (resolve) => require(['@/pageViews/disaster/index.vue'], resolve),
              meta: { keepAlive: false }
            },
          ]
        },

          // 防汛救灾
          {
              path: "/loanIndex",
              component: () => import("@/pageViews/loanPage/main.vue"),
              hidden: true,
              children: [
                  {
                      path: '/loan',
                      name: "loan",
                      component: (resolve) => require(['@/pageViews/loanPage/index.vue'], resolve),
                      meta: { keepAlive: false }
                  },
              ]
          },

          // 调查问卷
          {
              path: "/questionnaire",
              name: "questionnaire",
              component: () => import("@/pageViews/indexPage/questionnaire.vue"),
              meta: { keepAlive: false }
          },
        // 信用中心
        {
          path: "/serveHallIndex",
          name: "serveHallIndex",
          component: () => import("@/pageViews/serveHall/main.vue"),
          meta: { keepAlive: false },
          children: [
            {
              path: '/serveHall',
              name: "serveHall",
              component: (resolve) => require(['@/pageViews/serveHall/index.vue'], resolve),
              meta: { keepAlive: false }
            },
            {
              path: '/serveHallDetails',
              name: "serveHallDetails",
              component: (resolve) => require(['@/pageViews/serveHall/serveHallDetails.vue'], resolve),
              meta: { keepAlive: false, activeMenu: 'serveHall' }
            },
              {
                  path: '/serveHallDetailsJump',
                  name: "serveHallDetailsJump",
                  component: (resolve) => require(['@/pageViews/serveHall/serveHallDetailsJump.vue'], resolve),
                  meta: { keepAlive: false, activeMenu: 'serveHall' }
              }
          ]
        },
        // 政策速递
        {
          path: "/policyIndex",
          component: () => import("@/pageViews/policyPage/main.vue"),
          hidden: true,
          children: [
            {
              path: '/policy',
              name: "policy",
              component: (resolve) => require(['@/pageViews/policyPage/index.vue'], resolve),
              meta: { keepAlive: false }
            },
            {
              path: '/policyInfo',
              name: "policyInfo",
              component: (resolve) => require(['@/pageViews/policyPage/policy/index'], resolve),
              meta: { keepAlive: false, activeMenu: 'policy' }
            },
            {
              path: '/policyDetail',
              name: "policyDetail",
              component: (resolve) => require(['@/pageViews/policyPage/policy/detail'], resolve),
              meta: { keepAlive: false, activeMenu: 'policy' }
            },
            {
              path: '/newsInfo',
              name: "newsInfo",
              component: (resolve) => require(['@/pageViews/policyPage/news/index'], resolve),
              meta: { keepAlive: false, activeMenu: 'policy' }
            },
            {
              path: '/newsDetail',
              name: "newsDetail",
              component: (resolve) => require(['@/pageViews/policyPage/news/detail'], resolve),
              meta: { keepAlive: false, activeMenu: 'policy' }
            },
            {
              path: '/activityInfo',
              name: "activityInfo",
              component: (resolve) => require(['@/pageViews/policyPage/activity/index'], resolve),
              meta: { keepAlive: false, activeMenu: 'policy' }
            },
            {
              path: '/activityDetail',
              name: "activityDetail",
              component: (resolve) => require(['@/pageViews/policyPage/activity/detail'], resolve),
              meta: { keepAlive: false, activeMenu: 'policy' }
            }
          ]
        },
        // 智能政策匹配
        {
          path: "/smartPolicyPage",
          name: "smartPolicyPage",
          component: () => import("@/pageViews/smartPolicy/main.vue"),
          meta: { keepAlive: false },
          children: [
            {
              path: '/smartPolicy',
              name: "smartPolicy",
              component: (resolve) => require(['@/pageViews/smartPolicy/index.vue'], resolve),
              meta: { keepAlive: false }
            },
          ]
        },
        // 企业规模测算
        {
          path: "/entScalePage",
          name: "entScalePage",
          component: () => import("@/pageViews/entScale/main.vue"),
          meta: { keepAlive: false },
          children: [
            {
              path: '/entScale',
              name: "entScale",
              component: (resolve) => require(['@/pageViews/entScale/index.vue'], resolve),
              meta: { keepAlive: false, activeMenu: 'index' }
            },
          ]
        },
        // 统计中心
        {
          path: "/statistics",
          name: "statistics",
          component: () => import("@/pageViews/homePage/statistics.vue"),
          meta: { keepAlive: false, activeMenu: 'index' }
        },
        // 我要留言
        {
            path: "/messageBoard",
            name: "messageBoard",
            component: () => import("@/pageViews/messageBoard/index.vue"),
            meta: { keepAlive: false, activeMenu: 'index' }
        },
        // 帮助中心
        {
          path: "/helpCenter",
          name: "helpCenter",
          component: () => import("@/pageViews/helpCenter/index.vue"),
          meta: { keepAlive: false, activeMenu: 'index' }
        },
        // 房产估值
        {
          path: "/houseValuation",
          name: "houseValuation",
          component: () => import("@/pageViews/houseValuation/index.vue"),
          meta: { keepAlive: false, activeMenu: 'index' }
        },
        // 企业认证
        {
          path: "/authentication",
          name: "authentication",
          component: () => import("@/pageViews/homePage/authentication.vue"),
          meta: { keepAlive: false, activeMenu: 'index' }
        },
        // 电子签名授权
        {
          path: "/eSignAuth",
          name: "eSignAuth",
          component: () => import("@/pageViews/homePage/eSignAuth.vue"),
          meta: { keepAlive: false, requiresAuth: true, title: '电子签名授权' }
        },
        // 中介服务
        {
          path: "/agencyIndex",
          component: () => import("@/pageViews/agency/main.vue"),
          hidden: true,
          children: [
            {
              path: "/agency",
              name: "agency",
              component: (resolve) => require(["@/pageViews/agency/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'index' }
            },
            {
              path: "/agencyDetails",
              name: "agencyDetails",
              component: (resolve) => require(["@/pageViews/agency/agencyDetails.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'index' }
            },
          ]
        },
        // 企业培育
        {
          path: "/entFosterIndex",
          component: () => import("@/pageViews/entFoster/main.vue"),
          hidden: true,
          children: [
            {
              path: "/entFoster",
              name: "entFoster",
              component: (resolve) => require(["@/pageViews/entFoster/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'index' }
            },
            {
              path: "/entFosterDetails",
              name: "entFosterDetails",
              component: (resolve) => require(["@/pageViews/entFoster/details.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'index' }
            }
          ]
        },
        // 专精特新专区
        {
          path: "/specializedNewIndex",
          component: () => import("@/pageViews/specializedNew/main.vue"),
          hidden: true,
          children: [
            {
              path: "/specializedNew",
              name: "specializedNew",
              component: (resolve) => require(["@/pageViews/specializedNew/index.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'index' }
            },
            {
              path: "/specializedNewRoster",
              name: "specializedNewRoster",
              component: (resolve) => require(["@/pageViews/specializedNew/rosterPublicity.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewFinancing",
              name: "specializedNewFinancing",
              component: (resolve) => require(["@/pageViews/specializedNew/stockProduct.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewPolicy",
              name: "specializedNewPolicy",
              component: (resolve) => require(["@/pageViews/specializedNew/policyPage.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewAgency",
              name: "specializedNewAgency",
              component: (resolve) => require(["@/pageViews/specializedNew/agencyPage.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewFoster",
              name: "specializedNewFoster",
              component: (resolve) => require(["@/pageViews/specializedNew/entFoster.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewActivity",
              name: "specializedNewActivity",
              component: (resolve) => require(["@/pageViews/specializedNew/activityRegister.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNew/activityDetail",
              name: "specializedNewActivityDetail",
              component: (resolve) => require(["@/pageViews/specializedNew/activityDetail.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNew/entFosterDetail",
              name: "specializedNewEntFosterDetail",
              component: (resolve) => require(["@/pageViews/specializedNew/entFosterDetail.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewBusinessBureau",
              name: "specializedNewBusinessBureau",
              component: (resolve) => require(["@/pageViews/specializedNew/businessBureau.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            },
            {
              path: "/specializedNewBusinessBureau/articles",
              name: "specializedNewBusinessBureauArticles",
              component: (resolve) => require(["@/pageViews/specializedNew/articleList.vue"], resolve),
              meta: { keepAlive: false, activeMenu: 'specializedNew' }
            }
          ]
        },

      ]
    },
    {
      path: '/screenView',
      component: () => import('../pageViews/screenView'),
      redirect: '/screenView/index',
      children: [
        {
          path: 'index',
          component: () =>
            import(
              /* webpackChunkName: "screenView" */ '../pageViews/screenView/page/home'
            ),
          meta: { title: '甘肃省信易贷平台一屏统管' }
        },
        {
          path: 'finMechanism',
          component: () =>
            import(
              /* webpackChunkName: "screenView" */ '../pageViews/screenView/page/finMechanism'
            ),
          meta: { title: '甘肃省信易贷平台一屏统管' }
        },
        {
          path: 'enterpriseInformation',
          component: () =>
            import(
              /* webpackChunkName: "screenView" */ '../pageViews/screenView/page/enterpriseInformation'
            ),
          meta: { title: '甘肃省信易贷平台一屏统管' }
        },
        {
          path: 'operate',
          component: () =>
            import(
              /* webpackChunkName: "screenView" */ '../pageViews/screenView/page/operate'
            ),
          meta: { title: '甘肃省信易贷平台一屏统管' }
        },
        {
          path: 'dataCollection',
          component: () =>
            import(
              /* webpackChunkName: "screenView" */ '../pageViews/screenView/page/dataCollection'
            ),
          meta: { title: '甘肃省信易贷平台一屏统管' }
        }
      ]
    },
    {
      path: "/404",
      component: () => import("@/components/404"),
      meta: { keepAlive: false },
      hidden: true
    },
    {
      path: "*",
      redirect: "/404",
      meta: { keepAlive: false },
      hidden: true
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  const path = location.pathname.split('/')
  const item = findNodeByCode(substationList, path.includes('subplatform') ? path[2] : path[1])
  store.commit('user/setCurrSubstation', item)
  const hasToken = getToken();

  // 检查是否需要登录
  if (to.meta.requiresAuth && !hasToken) {
    // 需要登录但未登录，跳转到首页或登录页
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
    return;
  }

  if (hasToken) {
    if (to.path === "/") {
      next({ path: "/" });
    } else {
      const hasGetUserInfo = sessionStorage.getItem("userInfo");
      if (hasGetUserInfo) {
        await store.dispatch("user/getUserInfo");
        next();
      } else {
        try {
          next();
        } catch (error) {
          await store.dispatch("user/resetToken");
          that.$message.error(error || "Has Error");
          next(`/`);
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next('/');
    } else {
      next();
    }
  }
  if (!['product', 'productDetail'].includes(to.name)) {
  }
  if (!['loan', 'loanDetail'].includes(to.name)) {
  }
  if (!['financial', 'financialOrg', 'financialDetail', 'financialProdcutDetail'].includes(to.name)) {
  }
  if (!['financialProductIndex', 'financialProductDetail', 'financialProductApply'].includes(to.name)) {
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js